import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase } from "../../../utils/constants/headersForApi";

export const userDashboardApi = createApi({
  reducerPath: "userDashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getUserStats: builder.query({
      query: () => ({
        url: "/Stats/summary",
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getUserMonthWeekStats: builder.query({
      query: () => ({
        url: "/Stats/docssummary",
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getUserCategoryStats: builder.query({
      query: () => ({
        url: "/Stats/docsmacrosummary",
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getUserStatsPractice: builder.query({
      query: ({ practiceId = "", startDate = "", endDate = "" }) => ({
        url: `/Stats/practice-distribution-open-complete?practiceId=${practiceId}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getUserBarChartPractice: builder.query({
      query: ({ practiceId = "", startDate = "", endDate = "" }) => ({
        url: `/Stats/practice-summary?practiceId=${practiceId}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: headersBase(),
      }),
    }),
  }),
});

export const {
  useGetUserStatsQuery,
  useGetUserMonthWeekStatsQuery,
  useGetUserCategoryStatsQuery,
  useGetUserStatsPracticeQuery,
  useGetUserBarChartPracticeQuery,
} = userDashboardApi;
